import { Component, OnInit, SimpleChanges } from '@angular/core';
import { AgentHierarchyDetailsHandlerComponent } from './agent-hierarchy-details.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-hierarchy-details',
  templateUrl: './agent-hierarchy-details.component.html',
  styleUrls: ['./agent-hierarchy-details.component.scss'],
})
export class AgentHierarchyDetailsComponent extends AgentHierarchyDetailsHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['model'] && changes['model'].currentValue) {
      this.model = this.model;
      // console.log(this.service.responseIO);
    }
  }
}
